import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './CourseImageFill.css';
import { FALLBACK_IMAGE_SRC } from '../utils/placeholderImage';

const preventImageMenu = (event) => {
  event.preventDefault();
};

/**
 * Keeps the sharp course photo at object-fit: contain and covers the empty
 * bands with a blurred copy of the same image. A failed load drops the fill
 * and shows the fallback only.
 */
function CourseImageFill({
  src = '',
  alt = '',
  className = '',
  imageClassName = '',
  fallbackSrc = FALLBACK_IMAGE_SRC,
  loading,
}) {
  const sourceKey = src ?? '';
  const [failedSrc, setFailedSrc] = useState(null);
  const failed = failedSrc === sourceKey;
  const hasSource = sourceKey.length > 0 && sourceKey !== fallbackSrc;
  const showFill = hasSource && !failed;
  const displaySrc = showFill ? sourceKey : fallbackSrc;

  const handleError = (event) => {
    event.currentTarget.onerror = null;
    setFailedSrc(sourceKey);
  };

  const imageClass = ['course-image-fill__image', 'ui-integrated-image', imageClassName]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={['course-image-fill', className].filter(Boolean).join(' ')}>
      {showFill ? (
        <img
          src={sourceKey}
          alt=""
          aria-hidden="true"
          className="course-image-fill__backdrop ui-integrated-image"
          draggable={false}
          loading={loading}
          onContextMenu={preventImageMenu}
          onError={handleError}
        />
      ) : null}
      <img
        src={displaySrc}
        alt={alt}
        className={imageClass}
        draggable={false}
        loading={loading}
        onContextMenu={preventImageMenu}
        onError={showFill ? handleError : undefined}
      />
    </div>
  );
}

CourseImageFill.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  imageClassName: PropTypes.string,
  fallbackSrc: PropTypes.string,
  loading: PropTypes.oneOf(['lazy', 'eager']),
};

export default CourseImageFill;
